"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZODIAC_SIGNS = void 0;
exports.zodiac = zodiac;
exports.zodiacName = zodiacName;
exports.personalArcanaNumber = personalArcanaNumber;
exports.personalArcana = personalArcana;
const cards_js_1 = require("./cards.js");
exports.ZODIAC_SIGNS = [
    { id: 'aries', name: 'Овен' },
    { id: 'taurus', name: 'Телец' },
    { id: 'gemini', name: 'Близнецы' },
    { id: 'cancer', name: 'Рак' },
    { id: 'leo', name: 'Лев' },
    { id: 'virgo', name: 'Дева' },
    { id: 'libra', name: 'Весы' },
    { id: 'scorpio', name: 'Скорпион' },
    { id: 'sagittarius', name: 'Стрелец' },
    { id: 'capricorn', name: 'Козерог' },
    { id: 'aquarius', name: 'Водолей' },
    { id: 'pisces', name: 'Рыбы' },
];
const ZODIAC_RANGES = [
    { id: 'capricorn', startMonth: 12, startDay: 22, endMonth: 1, endDay: 19 },
    { id: 'aquarius', startMonth: 1, startDay: 20, endMonth: 2, endDay: 18 },
    { id: 'pisces', startMonth: 2, startDay: 19, endMonth: 3, endDay: 20 },
    { id: 'aries', startMonth: 3, startDay: 21, endMonth: 4, endDay: 19 },
    { id: 'taurus', startMonth: 4, startDay: 20, endMonth: 5, endDay: 20 },
    { id: 'gemini', startMonth: 5, startDay: 21, endMonth: 6, endDay: 20 },
    { id: 'cancer', startMonth: 6, startDay: 21, endMonth: 7, endDay: 22 },
    { id: 'leo', startMonth: 7, startDay: 23, endMonth: 8, endDay: 22 },
    { id: 'virgo', startMonth: 8, startDay: 23, endMonth: 9, endDay: 22 },
    { id: 'libra', startMonth: 9, startDay: 23, endMonth: 10, endDay: 22 },
    { id: 'scorpio', startMonth: 10, startDay: 23, endMonth: 11, endDay: 21 },
    { id: 'sagittarius', startMonth: 11, startDay: 22, endMonth: 12, endDay: 21 },
];
function assertDay(day) {
    if (!Number.isInteger(day) || day < 1 || day > 31)
        throw new RangeError(`day out of range: ${day}`);
}
function assertMonth(month) {
    if (!Number.isInteger(month) || month < 1 || month > 12)
        throw new RangeError(`month out of range: ${month}`);
}
function toRange(month, day) {
    return month * 100 + day;
}
function zodiac(day, month) {
    assertDay(day);
    assertMonth(month);
    const value = toRange(month, day);
    const range = ZODIAC_RANGES.find((r) => {
        if (r.startMonth <= r.endMonth) {
            return value >= toRange(r.startMonth, r.startDay) && value <= toRange(r.endMonth, r.endDay);
        }
        return value >= toRange(r.startMonth, r.startDay) || value <= toRange(r.endMonth, r.endDay);
    });
    if (!range)
        throw new RangeError(`zodiac not found for ${month}-${day}`);
    return range.id;
}
function zodiacName(day, month) {
    const sign = exports.ZODIAC_SIGNS.find((s) => s.id === zodiac(day, month));
    if (!sign)
        throw new RangeError('zodiac name not found');
    return sign.name;
}
function personalArcanaNumber(day) {
    assertDay(day);
    if (day <= 21)
        return day;
    return Math.floor(day / 10) + (day % 10);
}
function personalArcana(day) {
    const number = personalArcanaNumber(day);
    const card = cards_js_1.MAJOR_ARCANA.find((c) => c.number === number);
    if (!card)
        throw new RangeError(`major arcana not found for number ${number}`);
    return card;
}
//# sourceMappingURL=personal-arcana.js.map